import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import { Table } from 'reactstrap'
import './performance-rpm.css'

const sortOptions = [
    { label: 'Faixa Branca', value: 'percentFaixaBranca' },
    { label: 'Faixa Verde', value: 'percentFaixaVerde1' },
    { label: 'Faixa Azul', value: 'percentFaixaAzul' },
    { label: 'Faixa Verde 2', value: 'percentFaixaVerde2' },
    { label: 'Faixa Intermediaria', value: 'percentFaixaIntermediaria' },
    { label: 'Faixa Azul Freio Motor', value: 'percentFaixaAzulFreioMotor' },
    { label: 'Faixa Amarela', value: 'percentFaixaAmarela' },
    { label: 'Faixa Vermelha', value: 'percentFaixaVermelha' },
]


class PerformanceRPM extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            licenseNumbers: { options: [], loadingD: false },
            groups: [],
            table: [],
            tableReset: [],
            columns: [],
            alert: { msg: '', type: '' },
            loading: false,
            filter: {
                startPeriod: "",
                endPeriod: "",
                groupName: [],
                idDrivers: [],
                idVehicles: [],
            }

        }
    }




    componentDidMount() {
        this.getGroups();
        // this.getPerformance(this.state.filter)
    }

    percentSort = (key, ignore) => {
        if (key === this.state.sortOption && !ignore) {
            this.setState({ sortOption: '', table: JSON.parse(localStorage.getItem("tableReset")) })
        } else {
            let t = this.state.table.sort(function (a, b) { return (Reflect.get(a, key) < Reflect.get(b, key)) ? 1 : ((Reflect.get(b, key) < Reflect.get(a, key)) ? -1 : 0); });
            this.setState({ table: t, sortOption: key })
        }
    }


    getGroups = () => {
        axios
            .get(`${url}/v1/telemetria/admin/cache/groups/${this.props.token}`)
            .then(d => {
                // console.log(d.data);
                let groups = [];
                for (let i = 0; i < d.data.length; i++) {
                    groups.push({ value: d.data[i].name, label: d.data[i].name });
                }
                this.setState({ groups });
            })
            .catch(e => console.log(e.response));
    };


    getPerformance = body => {
        this.setState({ loading: true, table: [], alert: { msg: '', type: '' } });
        axios
            .post(`${url}/v1/telemetria/admin/report/performanceRpm/${this.props.token}`, body)
            .then(d => {
                console.log(d.data)
                if (d.data.length) {
                    localStorage.setItem("tableReset", JSON.stringify(d.data))
                    this.setState({ loading: false, table: d.data })
                    if (this.state.sortOption) {
                        this.percentSort(this.state.sortOption, true)
                    }
                } else {
                    this.setState({
                        loading: false,
                        alert: {
                            type: "",
                            msg:
                                "Não foi possivel localizar resultados para o período selecionado."
                        }
                    });
                }
            }).catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    exportPerformance = () => {
        this.setState({ loading: true });
        const body = this.state.filter
        axios
            .request({
                url: `${url}/v1/telemetria/admin/report/performanceRpm/export/${this.props.token}`,
                method: "POST",
                responseType: "blob", //important
                data: {
                    ...body,
                    columns: this.state.table.columns,
                    responseType: "blob"
                }
            })
            .then(({ data }) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute(
                    "download",
                    `${body.groupName.length > 0
                        ? "_" + body.groupName
                        : "_report"
                    }-${body.startPeriod}--${body.endPeriod}.xls`
                ); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.setState({ loading: false });
            })
            .catch(e => {
                console.log(e)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    isZero = (d) => {
        if (d.percentFaixaBranca === '0,00'
            && d.percentFaixaVerde1 === '0,00'
            && d.percentFaixaAzul === '0,00'
            && d.percentFaixaVerde2 === '0,00'
            && d.percentFaixaIntermediaria === '0,00'
            && d.percentFaixaAzulFreioMotor === '0,00'
            && d.percentFaixaAmarela === '0,00'
            && d.percentFaixaVermelha === '0,00') {
            return 'all-percent-zero'
        }
    }



    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startPeriod: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        value={this.state.filter.startPeriod}
                        max={getFDate()} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endPeriod: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startPeriod}
                        min={this.state.filter.startPeriod}
                        value={this.state.filter.endPeriod}
                        max={getFDate()}
                    />
                </div>

                <div>
                    <label htmlFor="drivers" className='toolbar-label'>Motoristas</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='drivers'
                        isLoading={this.state.drivers.loading}
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Motoristas"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.drivers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idDrivers: [] } })
                            }
                            else {
                                let idDrivers = []
                                i.forEach(d => idDrivers.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idDrivers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                        this.setState({ drivers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="vehicles" className='toolbar-label'>Frotas</label>
                    {/* Select Frotas */}
                    <Select
                        inputId='vehicles'
                        isLoading={this.state.licenseNumbers.loadingD}
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Frotas"
                        className='toolbar-select'
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise as frotas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.licenseNumbers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idVehicles: [] } })
                            }
                            else {
                                let idVehicles = []
                                i.forEach(d => idVehicles.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idVehicles } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ licenseNumbers: { ...this.state.licenseNumbers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/vehicles/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.licenseNmbr, value: d.vehicleId }))
                                        this.setState({ licenseNumbers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="groups" className='toolbar-label'>Grupos</label>

                    {/* Select Grupos */}
                    <Select
                        // isDisabled={this.state.loading}
                        // isLoading={this.state.collab.loading}
                        inputId='groups'
                        className='toolbar-select'
                        isMulti
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Grupos"
                        noOptionsMessage={e => { return `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.groups}
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, groupName: [] } })
                            }
                            else {
                                let groupName = []
                                i.forEach(d => groupName.push(d.value))
                                this.setState({ filter: { ...this.state.filter, groupName } })
                            }
                        }}
                        isClearable
                        isDisabled={this.state.loading} />

                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getPerformance(this.state.filter)}
                    disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading}
                />

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.length ? (
                    <div>
                        <div>
                            <input
                                type="button"
                                value='Exportar Excel'
                                className='excel-button'
                                onClick={() => this.exportPerformance()}
                                style={{ marginBottom: '20px' }}
                                disabled={this.state.loading}
                            />
                        </div>
                        <div className='sort-options'>
                            <span>Ordenar Faixas: </span>
                            {sortOptions.map((d, i) => {
                                return (
                                    <div key={i}>
                                        <label htmlFor={`_${d.value}`} className="txt-color">
                                            <input id={`_${d.value}`} type="checkbox" value={d.value} onChange={() => { this.percentSort(d.value) }} checked={this.state.sortOption === d.value} className='sort-options-checkbox' />
                                            {d.label}</label>
                                    </div>
                                )
                            })}
                        </div>
                        <Table responsive className="table-change-color standard-table">
                            <thead>
                                <tr>
                                    <th>Motorista</th>
                                    <th>Veículo</th>
                                    <th >Grupo</th>
                                    <th style={{minWidth: '100px', width: '100px'}}>Horas</th>
                                    <th style={{minWidth: '100px', width: '100px'}}>Distância</th>
                                    <th >Média de Consumo</th>
                                    <th >% Horas de Condução</th>
                                    <th >% Horas Ociosas</th>
                                    <th style={{ minWidth: '500px' }}>% Performance RPM</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.table.map((d, i) => {
                                    let zero = this.isZero(d)
                                    console.log(zero)
                                    return (
                                        <tr key={i} className="tr-table-change-color">
                                            <td>{d.driverName}</td>
                                            <td>{d.licenseNumber}</td>
                                            <td>{d.groupName}</td>
                                            <td style={{minWidth: '100px', width: '100px'}}>{d.time}</td>
                                            <td style={{minWidth: '100px', width: '100px'}}>{d.km}</td>
                                            <td>{d.avgFuel}</td>
                                            <td>{d.percentDrive}</td>
                                            <td>{d.percentIdle}</td>
                                            <td style={{ minWidth: '500px' }}>
                                                <div style={{ display: 'flex' }}>
                                                
                                                    <div className={`percent-rpm first-percent ${zero}`} style={{ width: d.percentFaixaBranca ? `${d.percentFaixaBranca.replace(',', '.')}%` : '0%', backgroundColor: '#dedede', height: '20px' }}><p style={{ color: 'black' }}>{d.percentFaixaBranca || 0}%</p></div>
                                                    <div className={`percent-rpm ${zero}`} style={{ width: d.percentFaixaVerde1 ? `${d.percentFaixaVerde1.replace(',', '.')}%` : '0%', backgroundColor: 'green', height: '20px' }}><p style={{ color: 'white' }}>{d.percentFaixaVerde1 || 0}%</p></div>
                                                    <div className={`percent-rpm ${zero}`} style={{ width: d.percentFaixaAzul ? `${d.percentFaixaAzul.replace(',', '.')}%` : '0%', backgroundColor: 'darkblue', height: '20px' }}><p style={{ color: 'white' }}>{d.percentFaixaAzul || 0}%</p></div>
                                                    <div className={`percent-rpm ${zero}`} style={{ width: d.percentFaixaVerde2 ? `${d.percentFaixaVerde2.replace(',', '.')}%` : '0%', backgroundColor: 'darkgreen', height: '20px' }}><p style={{ color: 'white' }}>{d.percentFaixaVerde2 || 0}%</p></div>
                                                    <div className={`percent-rpm ${zero}`} style={{ width: d.percentFaixaIntermediaria ? `${d.percentFaixaIntermediaria.replace(',', '.')}%` : '0%', backgroundColor: 'darkgray', height: '20px' }}><p style={{ color: 'black' }}>{d.percentFaixaIntermediaria || 0}%</p></div>
                                                    <div className={`percent-rpm ${zero}`} style={{ width: d.percentFaixaAzulFreioMotor ? `${d.percentFaixaAzulFreioMotor.replace(',', '.')}%` : '0%', backgroundColor: 'blue', height: '20px' }}><p style={{ color: 'white' }}>{d.percentFaixaAzulFreioMotor || 0}%</p></div>
                                                    <div className={`percent-rpm ${zero}`} style={{ width: d.percentFaixaAmarela ? `${d.percentFaixaAmarela.replace(',', '.')}%` : '0%', backgroundColor: 'yellow', height: '20px' }}><p style={{ color: 'black' }}>{d.percentFaixaAmarela || 0}%</p></div>
                                                    <div className={`percent-rpm last-percent ${zero}`} style={{ width: d.percentFaixaVermelha ? `${d.percentFaixaVermelha.replace(',', '.')}%` : '0%', backgroundColor: 'red', height: '20px' }}><p style={{ color: 'white' }}>{d.percentFaixaVermelha || 0}%</p></div>
                                                </div>

                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </Table>
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default PerformanceRPM